/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 422 unprocessable entity object
 * @export
 * @interface PutFleetsFleetIdMembersMemberIdUnprocessableEntity
 */
export interface PutFleetsFleetIdMembersMemberIdUnprocessableEntity {
    /**
     * error message
     * @type {string}
     * @memberof PutFleetsFleetIdMembersMemberIdUnprocessableEntity
     */
    error?: string;
}

/**
 * Check if a given object implements the PutFleetsFleetIdMembersMemberIdUnprocessableEntity interface.
 */
export function instanceOfPutFleetsFleetIdMembersMemberIdUnprocessableEntity(value: object): value is PutFleetsFleetIdMembersMemberIdUnprocessableEntity {
    return true;
}

export function PutFleetsFleetIdMembersMemberIdUnprocessableEntityFromJSON(json: any): PutFleetsFleetIdMembersMemberIdUnprocessableEntity {
    return PutFleetsFleetIdMembersMemberIdUnprocessableEntityFromJSONTyped(json, false);
}

export function PutFleetsFleetIdMembersMemberIdUnprocessableEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutFleetsFleetIdMembersMemberIdUnprocessableEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PutFleetsFleetIdMembersMemberIdUnprocessableEntityToJSON(json: any): PutFleetsFleetIdMembersMemberIdUnprocessableEntity {
    return PutFleetsFleetIdMembersMemberIdUnprocessableEntityToJSONTyped(json, false);
}

export function PutFleetsFleetIdMembersMemberIdUnprocessableEntityToJSONTyped(value?: PutFleetsFleetIdMembersMemberIdUnprocessableEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

